import { render, staticRenderFns } from "./lookFrozenDetail.vue?vue&type=template&id=3001f6b3&scoped=true"
import script from "./lookFrozenDetail.vue?vue&type=script&lang=js"
export * from "./lookFrozenDetail.vue?vue&type=script&lang=js"
import style0 from "./lookFrozenDetail.vue?vue&type=style&index=0&id=3001f6b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3001f6b3",
  null
  
)

export default component.exports